import { render } from "./ChangePasswordTab.vue?vue&type=template&id=6e785b8a"
import script from "./ChangePasswordTab.vue?vue&type=script&lang=js"
export * from "./ChangePasswordTab.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__